<template>
<v-row class="px-6 pa-6">
  <DoughnutChart
   
         :chartdata=" datacollection"
         :options="options"
       animation.animateRotate

        
/>
</v-row>
</template>
<script>


 import DoughnutChart from "@/components/Charts/doughnutchart.js";

export default {
  components: {
 
    DoughnutChart,
  },
  data: () => ({
   
    datacollection: {
   labels: [],
   datasets: [
        {
          data: [300],
          label: "Total Expense ",
          backgroundColor: "rgb(255, 205, 86)",
       
        },
        {
          data: [50],
          label: "Corp Balance",
          backgroundColor: "rgb(54, 162, 235)",
         
        },
        {
          data: [100],
          label: "Card Balance ",
          backgroundColor: "rgb(255, 99, 132)",
          
        },
      ],
      options:{
        cutout:120
      }
  //       datasets: [{
  //   label: 'My First Dataset',
  //   data: [300, 50, 100],
  //   backgroundColor: [
  //     'rgb(255, 99, 132)',
  //     'rgb(54, 162, 235)',
  //     'rgb(255, 205, 86)',

  //   ],
  //   options:{
  //     cutout:120
  //   }
    
  // }]
      
    },

   
  })
  
};
</script>